import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/index';
import { ActivatedRoute, Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Order } from '../../order/order.model';
import { User } from '../../auth/user.model';
import { AuthService } from '../../auth/auth.service';
import { UIService } from '../../shared/ui.service';
import { InvoiceService } from '../invoice.service';
import { MatDialog } from '@angular/material';
import { PicturesComponent } from './dialog/pictures/pictures.component';
import { StorageService } from '../../storage/storage.service';
import { Permission } from '../../access/access.service';


@Component({
  selector: 'app-invoice-details',
  templateUrl: './invoice-details.component.html',
  styleUrls: ['./invoice-details.component.css'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({backgroundColor: 'yellow', opacity: 0, height: '0px'}),
        animate(2000)
      ])
    ])
  ]
})
export class InvoiceDetailsComponent implements  OnInit, OnDestroy {
  user: User;
  invoice: Order;
  isLoading = false;
  invoiceType: string;
  currentLanguage = 'en';

  private loadingSubscription: Subscription;
  private selectedProjectSubscription: Subscription;
  currentProject: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private invoiceService: InvoiceService,
    private authentication: AuthService,
    private uiService: UIService,
    public dialog: MatDialog,
    private localStorage: StorageService
  ) { }



  ngOnInit() {

    this.currentLanguage = this.localStorage.getPreferredLanguage();

    this.loadingSubscription = this.uiService.loadingStateChanged.subscribe(isLoading => {
      this.isLoading = isLoading;
    });

    this.selectedProjectSubscription = this.uiService.selectedProjectChanged.subscribe(projectId => {
      this.router.navigate(['/invoices-legacy']);
    });

    this.user = this.authentication.getUser();
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      const type = params.get('type');
      this.invoiceType = type;
      this.getInvoiceById(id);
    });

  }

  getInvoiceById(id) {
    this.invoiceService.getInvoiceById(this.user.token, id).subscribe((result: Order) => {
        this.invoice = result;
        this.uiService.loadingStateChanged.next(false);
      },(error: Error) => {
        if(error ){
          this.invoice = null;
          this.uiService.loadingStateChanged.next(false);
      }});
  }

  ngOnDestroy(): void {
    this.loadingSubscription.unsubscribe();
    this.selectedProjectSubscription.unsubscribe();
  }

  openImagesDialog(){
    const dialogRef = this.dialog.open(PicturesComponent, {
      data: this.invoice,
    });
  }

  getInvoiceNumber() {
    let invoiceNumber = 0;
    switch (this.invoiceType) {
         case 'base_invoices': {
            invoiceNumber = this.invoice.invoice_number;
            break;
         }
         case 'other_invoices': {
            invoiceNumber = this.invoice.invoice_other_number;
            break;
         }
         case 'supplier_invoices': {
            invoiceNumber = this.invoice.invoice_supplier_number;
            break;
         }
         case 'extra_invoices': {
            invoiceNumber = this.invoice.invoice_extra_number;
            break;
         }
         case 'estimate_invoices': {
            invoiceNumber = this.invoice.invoice_estimate_number;
            break;
         }
         case 'day_extra_invoices': {
            invoiceNumber = this.invoice.invoice_number_days_extra;
            break;
         }
      }
      return invoiceNumber;
  }
}
